module.exports = __webpack_public_path__ + "img/fin_16_人类苏醒.af1b972c.jpg";